import React, { useState } from "react";
import { ReactComponent as IcArrow } from "../../../../../Assets/Images/Arrow-down.svg";

const ChatbotHeader = (props) => {
  const [ContextMenuIsOpen, setContextMenuIsOpen] = useState(false);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const toggleDelete = () => {
    setContextMenuIsOpen(false);
    props.ReqDeleteConversation();
  };

  return (
    <div className="chatbot-header">
      <div className="chatbot-head">
        <i
          className="feather-more-vertical"
          onClick={() => setContextMenuIsOpen(true)}
        ></i>
        <i className="feather-x" onClick={() => props.Close()} />
        <div className="title">
          {props.CustomTitle ? props.CustomTitle : "CX Copilot"}
        </div>
        {ContextMenuIsOpen ? (
          <>
            <div
              className="outline"
              onClick={() => setContextMenuIsOpen(false)}
            ></div>
            <div className="context-menu-content">
              <section className="menu-row" onClick={() => toggleDelete()}>
                <i className="feather-trash-2"></i>{" "}
                {translateText("delete_conversation")}
              </section>
            </div>
          </>
        ) : null}
      </div>
      <>
        {props.WillHideBanner ? null : (
          <>
            {props.showHeaderBanner ? (
              <div className="chatbot-header-banner-show">
                <div className="chatbot-header-banner-top">
                  <i className="chatbot-header-banner-icon feather-info" />
                  <p className="chatbot-header-banner-text vn">
                    {props.message}
                  </p>
                </div>
                <IcArrow
                  className="chatbot-header-banner-icon ic-arrow arrow-up"
                  onClick={props.onHeaderArrowClick}
                />
              </div>
            ) : (
              <div className="chatbot-header-banner-hidden">
                <IcArrow
                  className="chatbot-header-banner-icon ic-arrow arrow-down"
                  onClick={props.onHeaderArrowClick}
                />
              </div>
            )}
          </>
        )}
      </>
    </div>
  );
};

export default ChatbotHeader;
